import { useEffectOnce } from '@/hooks';
import { useTranslation } from 'react-i18next';

import styles from './Confirm.module.css';
import { Button } from '../button';

interface ConfirmProps {
  children: React.ReactNode;
  handleConfirm?: TypeAny;
  handleCancel?: TypeAny;
  disabled?: boolean;
}

export function Confirm({ handleConfirm, handleCancel, disabled, children }: ConfirmProps) {
  const { t } = useTranslation();

  useEffectOnce(() => {
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && typeof handleCancel === 'function') handleCancel();
    });
  });

  if (!children || (!handleConfirm && !handleCancel)) return null;

  return (
    <div
      data-testid="confirmOverlay"
      className={styles.confirm}
      onClick={handleCancel}
      role="button"
      tabIndex={0}
    >
      <div
        onClick={(e: TypeAny) => e.stopPropagation()}
        className={styles.confirmContent}
        role="button"
        tabIndex={0}
      >
        {children}

        <div className={styles.confirmContentCta}>
          {handleCancel && (
            <Button
              data-testid="cancelButton"
              onClick={handleCancel}
              disabled={disabled}
              size="small"
              theme="red"
            >
              {t('confirm.ctaCancel')}
            </Button>
          )}

          {handleConfirm && (
            <Button
              data-testid="confirmButton"
              onClick={handleConfirm}
              disabled={disabled}
              size="small"
              theme="cta"
            >
              {t('confirm.ctaConfirm')}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
